export const PRO_NUMBER_VALIDATION_MESSAGES = (proNumberLength) => {
  return {
    proNumberMin: `Pro must be ${proNumberLength} digits`,
    proNumberMax: `Pro number cannot be more than ${proNumberLength} digits`,
    duplicateNumber: "Duplicate pro number",
    invalidProNumber: "Pro number entered is invalid",
    invalidCheckDigit: "Invalid check digit",
    required: "Required",
  };
};
